import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */
const IconFacebook = ({ className, fill = 'currentColor' }) => {
    return (
        <svg
            className={'icon-facebook' + (className ? ` ${className}` : '')}
            fill={fill}
            height='15'
            viewBox='0 0 15 15'
            width='15'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M14.6667 7.33334C14.6667 3.28324 11.3834 0 7.33334 0C3.28324 0 0 3.28324 0 7.33334C0 10.9936 2.68169 14.0274 6.1875 14.5776V9.45313H4.32553V7.33334H6.1875V5.71771C6.1875 3.87979 7.28231 2.86459 8.95741 2.86459C9.75974 2.86459 10.599 3.00781 10.599 3.00781V4.8125H9.67424C8.76326 4.8125 8.47918 5.37779 8.47918 5.95773V7.33334H10.513L10.1879 9.45313H8.47917V14.5776C11.985 14.0274 14.6667 10.9936 14.6667 7.33334Z'
                fill={fill}/>
        </svg>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default IconFacebook;
